<template lang="pug">
.video-player.container.content
    .column.is-offset-1.is-10
        .videobox.extern(v-if="externalMedia")
            .video-url(v-if="externalMediaType === 'url'")
                video.video-js.vjs-city-offer.vjs-big-play-centered.minimalistic(
                    ref="player",
                    controls,
                    playsinline,
                    crossorigin,
                    poster="@/assets/Divergancy.jpg"
                    :aria-label="externalMedia"
                )
                    source(:src="externalMedia")
            .video-iframe.youtube(v-if="externalMediaType === 'youtube'")
                iframe(
                    :src="'https://www.youtube-nocookie.com/embed/' + externalMedia"
                    frameborder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen
                    :aria-label="externalMedia"
                )
            .video-iframe.vimeo(v-if="externalMediaType === 'vimeo'")
                iframe(
                    :src="'https://player.vimeo.com/video/' + externalMedia"
                    frameborder="0"
                    allow="autoplay; fullscreen"
                    allowfullscreen
                    :aria-label="externalMedia"
                )     
        .videobox.intern(v-else-if="src")
            video.video-js.vjs-city-offer.vjs-big-play-centered.minimalistic(
                ref="player",
                controls,
                playsinline,
                crossorigin,
                poster="@/assets/Divergancy.jpg"
            )
                source(:src="src", :type="mime")


</template>
<script>
import get from 'lodash.get'
import cloneDeep from 'lodash.clonedeep'
import videojs from 'video.js';
import 'videojs-http-source-selector';
import 'videojs-contrib-quality-levels';
import 'video.js/dist/video-js.min.css';

// import Hls from 'hls.js';
// import Plyr from 'plyr';

export default {
    name: 'VideoPlayer',
    props: {
        section: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            player: null
        };
    },
    watch: {
        src(fresh, old) {
            if (old && fresh !== old && this.player) {
                this.player.pause();                this.player.src([
                    {
                        type: this.mime,
                        src: this.src
                    }
                ]);
                // this.initialise()
                this.player.load();
                this.player.play();
            }
        }
    },
    computed: {
        externalMedia() {
            let externalMedia = get(this.section, 'contents.0.title');
            if ( externalMedia && externalMedia.length ){
                return externalMedia;
            } else {
                return undefined;
            }
        },

        externalMediaType() {
            let section = cloneDeep(this.section);
            let contents = get(section, 'contents', []);
            let media = 'url';
            if ( contents && contents.length ){
                let mediaContent = contents.find(content => content.key === 'title');
                media = get(mediaContent, 'settings.0.value', undefined);
            }
            return media;
        },

        media() {
            let section = cloneDeep(this.section);
            let contents = get(section, 'contents', []);
            let media;
            if ( contents && contents.length ){
                let mediaContent = contents.find(content => content.key === 'media' || content.key === 'video');
                media = get(mediaContent, 'media', undefined);
            }
            return media;
        },
        videoObject() {
            if(this.media) {
                return this.media.find(el => el.type === 'video');
            } else {
                return undefined;
            }
        },
        isHls() {
            if(this.videoObject && this.videoObject.video) {
                return !!get(this.videoObject.video, 'hls');
            } else {
                return undefined;
            }
        },
        mime() {
            if(this.videoObject) {
                if (this.isHls) {
                    return this.videoObject?.video?.hls?.mime;
                } else {
                    return this.videoObject?.video?.source?.mime;
                }
            } else {
                return undefined;
            }
        },
        src() {
            let src;
            if(this.videoObject) {

                    if (this.isHls) {
                        src = get(this.videoObject, 'video.hls.url');
                    } else {
                        src = get(this.videoObject, 'video.source.url');
                    }

            }
            return src;
        }
    },
    methods: {
        initialise() {
            if(this.$refs.player) {
                const options = {
                    muted: false,
                    language: 'de',
                    preload: 'auto',
                    fluid: true,
                    aspectRatio: '16:9',
                    autoplay: false,
                    // inactivityTimeout: 1,
                    html5: {
                        hls: {
                            overrideNative: true,
                            limitRenditionByPlayerDimensions: true,
                            useDevicePixelRatio: true,
                            bandwidth: 16777216
                        },
                        nativeAudioTracks: false,
                        nativeVideoTracks: false,
                        useBandwidthFromLocalStorage: true
                    },
                    controlBar: {
                        pictureInPictureToggle: false
                    }
                };
                this.player = videojs(this.$refs.player, options);
                this.player.httpSourceSelector();

                this.player.on('ended', () => {
                    this.player.posterImage.show();
                    this.player.currentTime(0);
                });

                this.player.on('touchstart', event => {
                    if (event.target.nodeName === 'VIDEO') {
                        if (this.player.paused()) this.player.play();
                        else this.player.pause();
                    }
                });

                this.player.ready(() => {
                  const playerEl = this.player.el();
                  if (playerEl) {
                    playerEl.setAttribute('aria-label', this.videoObject?.video?.basename || 'Videoplayer');
                  }
                });

                videojs.log.level('error');
            }
        }
    },
    mounted() {
        this.$nextTick(this.initialise);
        // this.initialise();
    },
    beforeDestroy() {
        if (this.player) this.player.dispose();
    }
};
</script>

<style lang="sass" nolang="scss" scoped>
    .video-iframe
        position: relative
        padding-bottom: 56.25%
        padding-top: 0
        height: 0
        overflow: hidden
        iframe
            position: absolute
            top: 0
            left: 0
            width: 100%
            height: 100%

</style>
